'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

/*
	Based on: https://github.com/paramaggarwal/react-dropzone
*/

var Dropzone = (function (_React$Component) {
    _inherits(Dropzone, _React$Component);

    function Dropzone(props) {
        _classCallCheck(this, Dropzone);

        _get(Object.getPrototypeOf(Dropzone.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Dropzone';
        this.ref = null;
        this.state = {
            isDragActive: false
        };
    }

    _createClass(Dropzone, [{
        key: 'onDragLeave',
        value: function onDragLeave() {
            this.setState({
                isDragActive: false
            });
        }
    }, {
        key: 'onDragOver',
        value: function onDragOver(e) {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy';

            this.setState({
                isDragActive: true
            });
        }
    }, {
        key: 'onDrop',
        value: function onDrop(e) {
            e.preventDefault();

            this.setState({
                isDragActive: false
            });

            var files;
            if (e.dataTransfer) {
                files = e.dataTransfer.files;
            } else if (e.target) {
                files = e.target.files;
            }

            if (this.props.onDrop) {
                files = Array.prototype.slice.call(files);
                this.props.onDrop(files);
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            this.ref && this.ref.click();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this = this;

            var className = (0, _classnames2['default'])('FileDragAndDrop', {
                active: this.state.isDragActive
            }, this.props.className);

            return _react2['default'].createElement('div', {
                className: className,
                onClick: this.onClick.bind(this),
                onDragLeave: this.onDragLeave.bind(this),
                onDragOver: this.onDragOver.bind(this),
                onDrop: this.onDrop.bind(this)
            }, _react2['default'].createElement('input', {
                style: { display: 'none' },
                type: 'file',
                multiple: true,
                ref: function ref(_ref) {
                    _this.ref = _ref;
                },
                onChange: this.onDrop.bind(this)
            }), _react2['default'].createElement('div', { className: 'FileDragAndDrop__label' }, this.state.isDragActive ? this.props.labelActive : this.props.label), this.props.children);
        }
    }]);

    return Dropzone;
})(_react2['default'].Component);

Dropzone.propTypes = {
    className: _propTypes2['default'].string,
    label: _propTypes2['default'].string,
    labelActive: _propTypes2['default'].string,
    onDrop: _propTypes2['default'].func.isRequired
};

Dropzone.defaultProps = {
    label: 'Drag Files Here',
    labelActive: 'Drop to Upload'
};

module.exports = Dropzone;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/FileDragAndDrop.js
// module id = 299
// module chunks = 0